import {ReactComponent as RawLogoWithText} from '../../assets/logo-with-text.svg';
import {ReactComponent as RawLogoNoText} from '../../assets/logo-v3.svg';

const LogoWithText = ({innerWidth=undefined,innerHeight=undefined,opacity=0.25,logoScalingFactor=1}) => {

    if (innerWidth === undefined || innerHeight === undefined) return <></>

    if (innerWidth < 200){
        const logoWidth = Math.min(innerWidth * 0.45, 30);
        const logoHeight = Math.min(innerWidth * 0.45, 30);
        return( <RawLogoNoText 
            width = {logoWidth}
            height = {logoHeight}
            opacity = {opacity}
            x = {( innerWidth / 2) - (logoWidth/2) }
            y = {( innerHeight / 2) - (logoHeight/2) }
        />)
    }


    const logoWidth = 32.62*5*logoScalingFactor;
    const logoHeight = 6.45*5*logoScalingFactor;

    return( <RawLogoWithText 
        width = {logoWidth}
        height = {logoHeight}
        opacity = {opacity}
        x = {( innerWidth / 2) - (logoWidth/2) }
        y = {( innerHeight / 2) - (logoHeight/2) }
    />)
}

export default LogoWithText;

